import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/zoom-in-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-1b30960c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generalContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ratingStars" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Califica tu experiencia")
], -1))
const _hoisted_3 = { class: "innerContainer" }
const _hoisted_4 = { class: "documentsContainer" }
const _hoisted_5 = { class: "documentsContainer__description" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "documentsContainer__documents" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalComponent, {
      open: _ctx.openSurvey,
      onCloseModal: _ctx.closeSurveyModal
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["open", "onCloseModal"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, "Documentos Finales del Producto: " + _toDisplayString(_ctx.displayedName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.displayedDescription), 1),
          _hoisted_6,
          _createElementVNode("p", null, _toDisplayString(_ctx.displayedInformation), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productDocuments, (document, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("a", {
                  href: document.url,
                  target: "_blank"
                }, [
                  _createElementVNode("button", null, [
                    _createTextVNode(_toDisplayString(document.name) + " ", 1),
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: document.name
                    }, null, 8, _hoisted_9)
                  ])
                ], 8, _hoisted_8)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}